import { Badge } from "@xola/ui-kit";
import React, { ReactNode } from "react";

const environmentNames: { [key: string]: string } = {
    staging: "Staging",
    preprod: "Pre-Production",
    sandbox: "Sandbox",
};

// Returns null rather than an empty element: ui-kit's Login only skips its label wrapper on a falsy label.
export const buildEnvironmentBadge = (): ReactNode => {
    const environment = process.env.ENVIRONMENT ?? "development";
    const name = environmentNames[environment];

    if (!name) {
        return null;
    }

    return (
        <Badge color="primary" className="!rounded">
            X2 {name}
        </Badge>
    );
};
